<template>
  <DashboardWidget canGoFullscreen title="Cash Flow Annuale" class="cash-flow-widget no-overflow">
    <OperativeTable dense>
      <tbody>
        <OperativeTableBodyRow :values="[values.utileEsercizio]">
          Utile d'esercizio
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ammortamenti]">
          Ammortamenti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.oneriFinanziari]">
          Oneri finanziari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaFondi]">
          ∆ Fondi
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.currentCashFlow]" strong>
          Current Cash Flow
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaLiquiditaDifferite]">
          ∆ Liquidità differite
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaCreditoImposta]">
          ∆ Credito d'imposta
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaDebitiCommerciali]">
          ∆ Debiti commerciali
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaAltriDebiti]">
          ∆ Altri debiti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaCreditoImposta]">
          ∆ Credito d'imposta (Risconto)
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.operatingCashFlow]" strong>
          Operating Cash Flow
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.investimenti]">
          Investimenti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.freeCashFlow]" strong>
          Free Cash Flow
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaBancheMLTermine]">
          ∆ Banche M/L Termine
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaBanche]">
          ∆ Banche
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaAltriDebitiFinanziari]">
          ∆ Altri debiti finanziari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.oneriFinanziari]">
          Oneri finanziari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaPN]">
          ∆ PN
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.flussoGestioneComplessiva]" strong>
          Flusso della gestione complessiva
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaLiquiditaImmediate]">
          ∆ Liquidità immediate
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.flussoCircolanteNetto]" strong>
          Flusso circolante netto
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
      </tbody>
    </OperativeTable>

    <template #fullscreen>
      <OperativeTable>
        <tbody>
        <OperativeTableBodyRow :values="[values.utileEsercizio]">
          Utile d'esercizio
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ammortamenti]">
          Ammortamenti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.oneriFinanziari]">
          Oneri finanziari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaFondi]">
          ∆ Fondi
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.currentCashFlow]" strong>
          Current Cash Flow
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaLiquiditaDifferite]">
          ∆ Liquidità differite
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaCreditoImposta]">
          ∆ Credito d'imposta
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaDebitiCommerciali]">
          ∆ Debiti commerciali
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaAltriDebiti]">
          ∆ Altri debiti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaCreditoImposta]">
          ∆ Credito d'imposta (Risconto)
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.operatingCashFlow]" strong>
          Operating Cash Flow
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.investimenti]">
          Investimenti
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.freeCashFlow]" strong>
          Free Cash Flow
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaBancheMLTermine]">
          ∆ Banche M/L Termine
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaBanche]">
          ∆ Banche
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaAltriDebitiFinanziari]">
          ∆ Altri debiti finanziari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.oneriFinanziari]">
          Oneri finanziari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaPN]">
          ∆ PN
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.flussoGestioneComplessiva]" strong>
          Flusso della gestione complessiva
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaLiquiditaImmediate]">
          ∆ Liquidità immediate
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.flussoCircolanteNetto]" strong>
          Flusso circolante netto
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        </tbody>
      </OperativeTable>
    </template>
  </DashboardWidget>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'dashboard-widget-cash-flow',
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
    OperativeTable: () => import('../../Operative/OperativeTable'),
    OperativeTableBodyRow: () => import('../../Operative/OperativeTableBodyRow'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
  },
};

</script>

<style lang="scss">

.cash-flow-widget {
  .operative-table-value-column {
    min-width: 1px;
  }
}

</style>
